export const APP_NAME = 'amoeba-web';
